export default "__VITE_PUBLIC_ASSET__ea9f2d6b__"